import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../context/WithConsumer';


export default class ModFabrics extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className="l-block">
	        	
	        	<div className="l-grid">
		        	
		        	<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12">
		        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        			{block.heading &&
					        	<h3 className="c-heading c-heading--large c-heading--space">{ block.heading }</h3>
				        	}
				        	{block.text &&
					        	<div className={"scope-text scope-text--" + block.text_size} dangerouslySetInnerHTML={ {__html: block.text } }></div>
				        	}
				        	<span className="c-heading c-heading--large c-heading--large-space">&nbsp;</span>
			        	</ScrollAnimation>
		        	</div>
		        	
		        	
		        	
		        	<div className="l-grid__col">
		        		<div className="c-lampshades__fabrics">
		        			<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						    	{block.fabric.map((fabric,i) =>
							    	{
							    		return (
								    		<div key={i} className="c-fabrics__swatch">
												{fabric.swatch_src && 
													<div className="c-fabrics__swatch__inner">
														<FadeIn duration={250}>
															{onload => (
																<img
																	alt={fabric.name} 
																	src={fabric.swatch_src} 
																	srcset={fabric.swatch_srcset}
																	onLoad={onload}
																/>
															)}
														</FadeIn>
													</div>
												}
												{fabric.swatch_hex &&
													<div className="c-fabrics__swatch__inner" style={{ backgroundColor: fabric.swatch_hex }}></div>
												}
												<p className="c-fabrics__swatch__text">{ fabric.name }</p>
											</div>	
							    		)
									}
						    	)}
						    </ScrollAnimation>
					    </div>
		        	</div>
		        </div>
	        
			</div>
		)
	};
};
